(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* One row always: try each size step, smallest change first, and keep the first that fits. */
(()=>{
  const h=document.querySelector('[data-hers-header]');if(!h)return;
  const nav=h.querySelector('.hers-nav'),logo=h.querySelector('.hers-logo'),tools=h.querySelector('.hers-tools');
  if(!nav||!logo||!tools)return;
  const STEPS=['','fit-1','fit-2','fit-3','fit-4'], ROOM=[32,28,22,16,12], root=document.documentElement;
  const fits=i=>{
    const l=(logo.querySelector('img')||logo).getBoundingClientRect(),n=nav.getBoundingClientRect(),t=tools.getBoundingClientRect();
    const rtl=root.dir==='rtl';
    const gapA=rtl?l.left-n.right:n.left-l.right, gapB=rtl?n.left-t.right:t.left-n.right;
    return gapA>=ROOM[i]&&gapB>=ROOM[i]&&nav.scrollWidth<=nav.clientWidth+1;
  };
  const fit=()=>{
    STEPS.forEach(c=>c&&h.classList.remove(c));
    if(window.innerWidth<=760)return;
    for(let i=0;i<STEPS.length;i++){
      if(STEPS[i])h.classList.add(STEPS[i]);
      if(fits(i))return;
      if(STEPS[i]&&i<STEPS.length-1)h.classList.remove(STEPS[i]);
    }
  };
  let t;addEventListener('resize',()=>{clearTimeout(t);t=setTimeout(fit,120)});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
  addEventListener('load',fit);fit();
})();

(()=>{
  const h=document.querySelector('[data-hers-header]');if(!h)return;
  const phone=window.matchMedia('(max-width:760px)');
  let last=Math.max(0,scrollY),ticking=false;
  const update=()=>{
    ticking=false;
    const y=Math.max(0,scrollY);               /* iOS bounce can report negatives */
    h.classList.toggle('is-scrolled',y>24);
    document.documentElement.classList.toggle('k-scrolled',y>24);
    if(!phone.matches){h.classList.remove('is-hidden');last=y;return}
    /* never hide while the menu, bag or a popup is open, or near the top */
    if(document.documentElement.classList.contains('k-layer-open')||y<90){h.classList.remove('is-hidden');last=y;return}
    const d=y-last;
    if(Math.abs(d)<6)return;                    /* ignore tiny jitters */
    h.classList.toggle('is-hidden',d>0);        /* down hides, up shows */
    last=y;
  };
  addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}},{passive:true});
  phone.addEventListener?phone.addEventListener('change',update):phone.addListener(update);
  /* anything focused inside the header (keyboard users) brings it back */
  h.addEventListener('focusin',()=>h.classList.remove('is-hidden'));
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hers-experience"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.querySelector('[data-hx]');if(!root)return;document.documentElement.classList.remove('no-js');const intro=root.querySelector('[data-hx-intro]');setTimeout(()=>intro?.classList.add('is-gone'),1050);const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12});root.querySelectorAll('.hx-reveal').forEach(el=>io.observe(el));const cursor=root.querySelector('[data-hx-cursor]');if(cursor&&matchMedia('(pointer:fine)').matches){addEventListener('pointermove',e=>{cursor.style.transform=`translate(${e.clientX}px,${e.clientY}px) translate(-50%,-50%)`});root.querySelectorAll('a,button').forEach(el=>{el.addEventListener('pointerenter',()=>cursor.classList.add('is-active'));el.addEventListener('pointerleave',()=>cursor.classList.remove('is-active'))})}root.querySelectorAll('.hx-magnetic').forEach(el=>{el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();el.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.12}px,${(e.clientY-r.top-r.height/2)*.12}px)`});el.addEventListener('pointerleave',()=>el.style.transform='')});root.querySelectorAll('.hx-product__form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const button=form.querySelector('button');button.textContent='…';try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams(new FormData(form))});button.textContent='✓'}catch(error){button.textContent='!'}setTimeout(()=>button.textContent='+',1400)}))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hers-rhea-home"] && !Shopify.designMode) return;
  try {
    
/* On phones the offers sit on top of each other, so the banner needs a height.
   Measure the tallest offer and use that, rather than trusting a formula. */
(()=>{
  const hero=document.querySelector('.rh-hero');
  if(!hero)return;
  const slides=[...hero.querySelectorAll('[data-slide]')];
  if(!slides.length)return;
  const phone=window.matchMedia('(max-width:900px)');
  const fit=()=>{
    if(!phone.matches){hero.style.removeProperty('height');return}
    let tallest=0;
    slides.forEach(s=>{
      const copy=s.querySelector('.rh-ps-copy'), media=s.querySelector('.rh-ps-media');
      if(!copy||!media)return;
      const st=getComputedStyle(s);
      const pad=(parseFloat(st.paddingTop)||0)+(parseFloat(st.paddingBottom)||0);
      const gap=parseFloat(st.rowGap)||18;
      const h=media.getBoundingClientRect().height+gap+copy.scrollHeight+pad;
      if(h>tallest)tallest=h;
    });
    if(tallest>0)hero.style.height=Math.ceil(tallest)+'px';
  };
  let t;addEventListener('resize',()=>{clearTimeout(t);t=setTimeout(fit,150)});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
  addEventListener('load',fit);
  setTimeout(fit,300);
  fit();
})();

(()=>{document.querySelectorAll('[data-rh]').forEach(root=>{
  const hero=root.querySelector('.rh-hero'),slides=[...root.querySelectorAll('[data-slide]')],dots=[...root.querySelectorAll('[data-dot]')];
  const rtl=document.documentElement.dir==='rtl';let active=0,timer;
  const show=n=>{
    if(!slides.length)return;
    active=(n+slides.length)%slides.length;
    slides.forEach((s,i)=>{s.classList.toggle('is-active',i===active);s.setAttribute('aria-hidden',i===active?'false':'true')});
    dots.forEach((d,i)=>{d.classList.toggle('is-active',i===active);d.setAttribute('aria-selected',i===active?'true':'false')});
    const cur=dots[active];if(cur&&cur.parentElement.scrollWidth>cur.parentElement.clientWidth){
      cur.parentElement.scrollTo({left:cur.offsetLeft-(cur.parentElement.clientWidth-cur.offsetWidth)/2,behavior:'smooth'})}
  };
  /* manual by default; only moves on its own if switched on in Customize */
  const auto=hero&&hero.dataset.autoplay==='1'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
  const play=()=>{clearInterval(timer);if(auto&&slides.length>1)timer=setInterval(()=>show(active+1),6000)};
  root.querySelector('.rh-next')?.addEventListener('click',()=>{show(active+1);play()});
  root.querySelector('.rh-prev')?.addEventListener('click',()=>{show(active-1);play()});
  dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);play()}));
  /* swipe on phones; in Arabic the direction mirrors */
  if(hero&&slides.length>1){
    let x0=null,y0=null;
    hero.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
    hero.addEventListener('touchend',e=>{
      if(x0===null)return;const dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;x0=null;
      if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.3)return;
      const forward=rtl?dx>0:dx<0;show(active+(forward?1:-1));play();
    },{passive:true});
    hero.addEventListener('keydown',e=>{
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
      const forward=(e.key==='ArrowRight')!==rtl;show(active+(forward?1:-1));play();
    });
  }
  show(0);play();
  root.querySelectorAll('[data-tab]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-tab]').forEach(x=>x.classList.toggle('is-active',x===b));root.querySelectorAll('[data-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.panel===b.dataset.tab))}));const o=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');o.unobserve(e.target)}}),{threshold:.1});root.querySelectorAll('.rh-reveal').forEach(e=>o.observe(e))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(()=>{
  /* live price for the variant picker */
  const sel=document.querySelector('[data-variant-select]');
  if(sel){
    const p=document.querySelector('[data-price]'),c=document.querySelector('[data-compare]'),gal=document.querySelector('.hp-gallery');
    const applyVariant=(o,isFirstLoad)=>{
      if(p)p.innerHTML=o.dataset.price;
      if(c){c.innerHTML=o.dataset.compare||'';c.hidden=!o.dataset.compare}
      /* stock for the chosen colour */
      const low=document.querySelector('[data-low-stock]');
      if(low){
        const at=parseInt(low.dataset.lowAt,10)||6;
        const n=parseInt(o.dataset.stock,10);
        if(!isNaN(n)&&n>0&&n<=at){
          low.textContent=(window.HERS_T&&window.HERS_T.lowStock||'Only {{ count }} left').replace('{{ count }}',n);
          low.hidden=false;
        } else low.hidden=true;
      }

      /* show that colour's photo. Match the photo itself, not its position:
         a video or 3D model among the media would shift every position. */
      if(gal&&typeof gal.showShot==='function'){
        let n=-1;
        if(o.dataset.imageId){
          const shot=gal.querySelector('[data-img-id="'+o.dataset.imageId+'"]');
          if(shot)n=parseInt(shot.dataset.shot,10);
        }
        if(n<0&&o.dataset.image!==undefined){
          const p=parseInt(o.dataset.image,10);
          if(!isNaN(p)&&gal.querySelector('[data-shot="'+p+'"]'))n=p;
        }
        /* no photo linked to this colour in Shopify: match the colour's name against
           the photos themselves, so choosing Blue still lands on the blue one */
        if(n<0&&o.dataset.name){
          const words=o.dataset.name.split(/[\s/,+-]+/).filter(w=>w.length>2);
          const shots=[...gal.querySelectorAll('[data-shot]')];
          for(const w of words){
            const hit=shots.find(sh=>(sh.dataset.alt||'').includes(w));
            if(hit){n=parseInt(hit.dataset.shot,10);break}
          }
        }
        if(n>=0)gal.showShot(n);
      }
    };

    sel.addEventListener('change',()=>applyVariant(sel.selectedOptions[0],false));

    /* the picker already has a colour chosen when the page opens — show its photo,
       and its stock, without waiting for the shopper to change anything */
    const startWhenReady=()=>{
      const o=sel.selectedOptions[0];
      if(o)applyVariant(o,true);
    };
    if(document.readyState==='complete')setTimeout(startWhenReady,60);
    else addEventListener('load',()=>setTimeout(startWhenReady,60));
  }


  /* tidy the description and lift out ingredients / how to use */
  const desc=document.querySelector('[data-desc]');
  if(!desc)return;
  const title=(document.querySelector('.hp-product h1')||{}).textContent||'';
  const norm=t=>(t||'').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim().toLowerCase();

  desc.querySelectorAll('img,figure,iframe').forEach(n=>n.remove());

  /* unwrap a single wrapping div so we can walk its children */
  while(desc.children.length===1&&/^(DIV|SECTION|ARTICLE)$/.test(desc.firstElementChild.tagName))
    desc.firstElementChild.replaceWith(...desc.firstElementChild.childNodes);

  /* drop leading blanks and a first line that just repeats the product name */
  const isBlank=n=>n.nodeType===3?!norm(n.textContent):(n.nodeType===1&&!norm(n.textContent)&&!n.querySelector('li'));
  while(desc.firstChild&&isBlank(desc.firstChild))desc.firstChild.remove();
  if(desc.firstElementChild&&norm(desc.firstElementChild.textContent)===norm(title))desc.firstElementChild.remove();
  while(desc.firstChild&&isBlank(desc.firstChild))desc.firstChild.remove();

  const KEYS={
    /* \b only understands Latin letters, so Arabic alternatives must not rely on it */
    ingredients:/^(?:(?:key\s+|active\s+|main\s+)?ingredients?\b|what'?s\s+inside\b|المكونات|مكونات)/i,
    how:/^(?:how\s+to\s+(?:use|apply)\b|directions\b|usage\b|application\b|method\b|طريقة\s+الاستخدام|طريقة\s+الاستعمال|الاستخدام|الاستعمال)/i
  };
  const slots={ingredients:document.querySelector('[data-slot="ingredients"]'),how:document.querySelector('[data-slot="how"]')};
  const taken={ingredients:!!(slots.ingredients&&norm(slots.ingredients.textContent)),how:!!(slots.how&&norm(slots.how.textContent))};

  /* what does this node label, if anything? */
  function labelOf(n){
    if(n.nodeType!==1)return null;
    const lead=n.matches('h1,h2,h3,h4,h5,h6')?n:(n.firstElementChild&&n.firstElementChild.matches('strong,b')&&
               norm(n.textContent).startsWith(norm(n.firstElementChild.textContent))?n.firstElementChild:null);
    if(!lead)return null;
    const t=norm(lead.textContent).replace(/[:：\-–]+$/,'').trim();
    if(t.length>40)return null;
    for(const k in KEYS)if(KEYS[k].test(t))return {key:k,lead};
    return {key:null,lead};              /* some other heading: ends a section */
  }

  let current=null;
  [...desc.childNodes].forEach(n=>{
    const lab=labelOf(n);
    if(lab){
      if(lab.key&&slots[lab.key]&&taken[lab.key]){
        /* the product's own field already covers this: drop the duplicate from the description */
        current='__drop';
        if(lab.lead!==n){lab.lead.remove();}
        n.remove();
        return;
      }
      if(lab.key&&slots[lab.key]&&!taken[lab.key]){
        current=lab.key;
        /* "Ingredients: rosemary, biotin" in one paragraph: keep the words after the label */
        if(lab.lead!==n){
          lab.lead.remove();
          n.innerHTML=n.innerHTML.replace(/^\s*[:：\-–]\s*/,'');
          if(norm(n.textContent))slots[current].appendChild(n); else n.remove();
        } else n.remove();
        return;
      }
      current=null;
    }
    if(current==='__drop'){n.remove();return;}
    if(current)slots[current].appendChild(n);
  });

  /* bundle lists: "Hair Stick Wax:" reads better without the colon once it sits on its own line */
  document.querySelectorAll('.hp-rte li>strong:first-child,.hp-rte li>b:first-child').forEach(b=>{
    b.textContent=b.textContent.replace(/\s*[:：]\s*$/,'');
  });

  for(const k in slots){
    const s=slots[k];if(!s)continue;
    if(norm(s.textContent))s.closest('.hp-acc').hidden=false;
  }
  /* if everything was lifted out, the description panel has nothing left */
  if(!norm(desc.textContent)){const d=desc.closest('.hp-acc');d.hidden=true;
    const nx=document.querySelector('.hp-acc:not([hidden])');if(nx)nx.open=true;}
})();

  } catch(e) { console.error(e); }
})();
})();
